// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PayWay_style_wrapper__3FWxa","center":"PayWay_style_center__2f8a7"};